import { ClientHandler } from '../types';
import { disneyHandler } from './client-handlers/DISNEY/disney-handler';
import { resumidoHandler } from './client-handlers/RESUMIDO/resumido-handler';

const CLIENT_HANDLERS: Record<string, ClientHandler> = {
  DISNEY: disneyHandler,
  RESUMIDO: resumidoHandler,
  TEST: disneyHandler // TEST usa las mismas reglas que DISNEY
};

export const getClientHandler = (clientId: string): ClientHandler => {
  return CLIENT_HANDLERS[clientId] || {};
};
